export function identify(wallet) {
    analytics.identify(wallet, {}, { context: { ip: '0.0.0.0' } });
}
//# sourceMappingURL=a-identify.js.map